<template>
  <component
    :is="resolvedComponent"
    v-if="resolvedComponent && !isAccordionDrilldown"
    v-bind="node.props"
    @row-detail="$emit('row-detail', $event)"
    @input="$emit('input', $event)"
    @filter-change="$emit('filter-change', $event)"
    @update:options="$emit('update:options', $event)"
    @update:reference-date="$emit('update:reference-date', $event)"
    @submit="$emit('submit', $event)"
    @action="$emit('action', $event)"
  >
    <DashboardNodeRenderer
      v-for="(child, index) in node.children"
      :key="child.id || index"
      :node="child"
      :data-field="childDataField(child, index)"
      @row-detail="$emit('row-detail', $event)"
      @input="$emit('input', $event)"
      @filter-change="$emit('filter-change', $event)"
      @update:options="$emit('update:options', $event)"
      @update:reference-date="$emit('update:reference-date', $event)"
      @submit="$emit('submit', $event)"
      @action="$emit('action', $event)"
    />
  </component>

  <DashboardAccordionLazyTabs
    v-else-if="isAccordionDrilldown"
    v-bind="node.props"
    @row-detail="$emit('row-detail', $event)"
    @input="$emit('input', $event)"
    @filter-change="$emit('filter-change', $event)"
    @update:options="$emit('update:options', $event)"
    @update:reference-date="$emit('update:reference-date', $event)"
    @submit="$emit('submit', $event)"
    @action="$emit('action', $event)"
  />

  <div
    v-else
    class="dashboard-node-renderer__unknown"
  >
    Tipo de componente não reconhecido: "{{ node.type }}"
  </div>
</template>

<script>
import dashboardComponentRegistry from './dashboardComponentRegistry'
import DashboardAccordionLazyTabs from './DashboardAccordionLazyTabs.vue'
import { childDataField as resolveChildDataField } from './dataFieldUtils'

export default {
  name: 'DashboardNodeRenderer',
  components: { DashboardAccordionLazyTabs },
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    resolvedComponent() {
      return dashboardComponentRegistry[this.node.type] || null
    },
    isAccordionDrilldown() {
      return this.resolvedComponent === DashboardAccordionLazyTabs
    }
  },
  created() {
    if (process.env.NODE_ENV !== 'production' && !this.resolvedComponent) {
      // eslint-disable-next-line no-console
      console.warn(
        `DashboardNodeRenderer: tipo "${this.node.type}" não existe no dashboardComponentRegistry — renderizando placeholder.`
      )
    }
  },
  methods: {
    childDataField(child, index, prefix) {
      return resolveChildDataField(this.node, child, index, prefix)
    }
  }
}
</script>

<style lang="scss">
.dashboard-node-renderer__unknown {
  padding: 10px 14px;
  border: 1px dashed var(--ds-color-black-020);
  border-radius: 6px;
  font-size: 0.8rem;
  color: var(--ds-color-black-055);
}
</style>
